import { createElement } from "react";
import React from "react";
import { equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { second, minute, hour } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Remote$1 } from "../Remoting.js";

export function Buttons_SaveButton_Z19F3502D(buttons_SaveButton_Z19F3502DInputProps) {
    const onClick = buttons_SaveButton_Z19F3502DInputProps.onClick;
    const disabled = buttons_SaveButton_Z19F3502DInputProps.disabled;
    const saveDate = buttons_SaveButton_Z19F3502DInputProps.saveDate;
    const tooltipProps = buttons_SaveButton_Z19F3502DInputProps.tooltipProps;
    const tooltipError = buttons_SaveButton_Z19F3502DInputProps.tooltipError;
    const tooltipOk = buttons_SaveButton_Z19F3502DInputProps.tooltipOk;
    const label = buttons_SaveButton_Z19F3502DInputProps.label;
    const key = buttons_SaveButton_Z19F3502DInputProps.$key;
    return createElement("button", createObj(Helpers_combineClasses("btn", toList(delay(() => append(singleton(["className", "btn-primary"]), delay(() => append(singleton(["className", "justify-self-start"]), delay(() => append(singleton(["key", `${key}-button`]), delay(() => {
        let elems_1;
        return append(singleton((elems_1 = toList(delay(() => append(singleton(label), delay(() => {
            const matchValue = saveDate;
            switch (matchValue.tag) {
                case 1:
                    return singleton(createElement("span", createObj(Helpers_combineClasses("loading", ofArray([["className", "loading-spinner"], ["key", `${key}-spinner`]])))));
                case 2: {
                    const apiError = matchValue.fields[0];
                    console.warn(some(`Error on save ${apiError.ErrorMessage}`));
                    return singleton(createElement("div", createObj(Helpers_combineClasses("tooltip", toList(delay(() => append(singleton(["data-tip", tooltipError(apiError)]), delay(() => append(singleton(["className", "tooltip-error"]), delay(() => append(tooltipProps, delay(() => append(singleton(["children", "❗"]), delay(() => singleton(["key", `${key}-error-tooltip`])))))))))))))));
                }
                case 3: {
                    const dateTime = matchValue.fields[0];
                    return singleton(createElement("div", createObj(Helpers_combineClasses("tooltip", toList(delay(() => append(singleton(["data-tip", `${tooltipOk} @ ${hour(dateTime)}:${minute(dateTime)}:${second(dateTime)}`]), delay(() => append(singleton(["className", "tooltip-success"]), delay(() => append(tooltipProps, delay(() => append(singleton(["key", `${key}-ok-tooltip`]), delay(() => {
                        let elems;
                        return singleton((elems = [createElement("span", {
                            key: `${key}-ok-text`,
                            children: "✓",
                            className: "font-bold text-green-500",
                        })], ["children", reactApi.Children.toArray(Array.from(elems))]));
                    }))))))))))))));
                }
                default: {
                    return empty();
                }
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])), delay(() => ((disabled ? true : equals(saveDate, new Remote$1(1, []))) ? append(singleton(["aria-disabled", true]), delay(() => singleton(["disabled", true]))) : singleton(["onClick", (_arg) => {
            onClick();
        }]))));
    })))))))))));
}

